import React, {useState} from 'react'
import ButtonCircle from '../ButtonCircle/ButtonCircle';
import './ButtonIcon.css'



const ButtonIcon = ({
    onClick = () => { },
    Icon = () => { },
    text = '',
    type = '',
    isIconCircle=false,
    style=null,
    isVisible=true,
    animation='',
    widthCircle = "2.7vw",
    widthIcon = "0.8vw",

}) => {
    const [backgroundCircle, setbackgroundCircle] = useState('var(--primary-color-dark)')
    
    const mouseOver = ()=>{
        setbackgroundCircle('white');
    }

    const mouseOut = ()=>{
        setbackgroundCircle('var(--primary-color-dark)');
    }
    
    return (
        isVisible&&<div  
        
            className={`button-icon-content ${animation} ${type} ${style?.icon_content}`} 
            onClick={onClick} 
            onMouseOver={mouseOver}
            onMouseOut={mouseOut}>
            
            {
            isIconCircle?
            <ButtonCircle
                Icon={Icon}
                widthCircle={widthCircle}
                widthIcon={widthIcon}
                backgroundCircle={backgroundCircle}
            />
            :
            <Icon  className='icon-button-icon' style={{height:widthIcon}}/>
            }

            <div className={`text-button-icon ${style?.text_button}`}>{text}</div>
        </div>
    )
}


export default ButtonIcon
